import React from 'react';

export default function HelpPage()
{
  return <h1>HelpPage</h1>
}
